import {
  businessCodeColumnDefinition,
  businessUnitColumnDefinition,
  companyCodeColumnDefinition,
  countryCodeColumnDefinition,
  legalEntityColumnDefinition,

  bookTypeColumnDefinition,
  countryTaxTypeColumnDefinition,
  currencyCodeColumnDefinition,
  glAccountColumnDefinition,
  slAccountColumnDefinition,
  slBalanceColumnDefinition,
  taxYearColumnDefinition,
  tradingPartnerColumnDefinition,
  customGroupNameColumnDefinition,
} from '../columnDefinitions';
import { alignLeftCellStyle } from '@common/cellStyles';
import { assignmentTypes } from '../authorization/assignmentTypes';

const getGroupingColumn = groupType => {
  const columnDefsByGroupType = {
    BZ: { ...businessCodeColumnDefinition, headerName: 'Business', ...alignLeftCellStyle },
    BU: { ...businessUnitColumnDefinition, ...alignLeftCellStyle },
    CC: { ...companyCodeColumnDefinition, ...alignLeftCellStyle },
    CO: { ...countryCodeColumnDefinition, headerName: 'Country', ...alignLeftCellStyle },
    LE: { ...legalEntityColumnDefinition, headerName: 'Legal Entity', ...alignLeftCellStyle },
    GR: customGroupNameColumnDefinition,
  };

  const groupingColumn = columnDefsByGroupType[groupType];

  return groupingColumn
    ? [{ ...groupingColumn, field: 'name' }]
    : [];
};

export const getColumnDefinitions = groupType => {
  const countryCodeColumn = groupType !== assignmentTypes.COUNTRIES
    ? [countryCodeColumnDefinition]
    : [];

  return [
    ...getGroupingColumn(groupType),
    {
      ...slAccountColumnDefinition,
      field: 'slAccountDesc',
      headerName: 'BSM Account',
    },
    {
      ...glAccountColumnDefinition,
      field: 'glAccount',
      headerName: 'Associated GL Account',
    },
    tradingPartnerColumnDefinition,
    ...countryCodeColumn,
    countryTaxTypeColumnDefinition,
    taxYearColumnDefinition,
    {
      ...currencyCodeColumnDefinition,
      headerName: 'Tax Currency',
    },
    bookTypeColumnDefinition,
    {
      ...slBalanceColumnDefinition,
      field: 'slBalance',
      headerName: 'BSM Account Balance',
    },
  ];
};
